module.exports = __webpack_public_path__ + "img/kommune-723.9af92e0c.svg";